/* eslint-disable @typescript-eslint/no-unused-vars */
import 'keen-slider/keen-slider.min.css'
import React, { useCallback } from 'react'
import { Card, Container, Carousel } from './styles'
import { useDispatch } from 'react-redux'

import history from '../../services/history'
import ContinueTextImg from '../../assets/continue-text.png'
import ContinueVideoImg from '../../assets/continue-video.png'
import { changeRecentPath } from '../../store/modules/recentView/action'
import { useGetCarousel } from './use-get-carousel'

import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs'

interface ContinueContentProps {
  content: any[]
}

const ContinueContent: React.FC<ContinueContentProps> = ({ content }) => {
  const dispatch = useDispatch()

  const [ref, slider] = useGetCarousel()

  const handleLink = useCallback(
    (item) => {
      dispatch(changeRecentPath('/home'))
      history.push(
        `/course/${item.courseId}/module/${item.moduleId}/lesson/${item.lessonId}/chapter/${item.chapterId}`
      )
    },
    [dispatch]
  )

  return (
    <>
      {content.length ? (
        <Container>
          <div className="upper-content">
            <h2 className="title">Continuar de onde parou</h2>
            <div className="arrows">
              <button className="left" onClick={slider.current?.prev}>
                <BsArrowLeftShort size={28} />
              </button>
              <button className="right" onClick={slider.current?.next}>
                <BsArrowRightShort size={28} />
              </button>
            </div>
          </div>
          <Carousel ref={ref} className="keen-slider">
            {content.map((item, idx) => (
              <div key={idx} className="keen-slider__slide" style={{ overflow: 'visible' }}>
                <Card onClick={() => handleLink(item)}>
                  <img
                    className="image"
                    src={item.type === 'excerto' ? ContinueTextImg : ContinueVideoImg}
                    alt=""
                  />
                  <div className="texts">
                    <div>
                      <p className="info">
                        <b className="label">Curso:</b>
                        {item.courseName}
                      </p>
                      <p className="info">
                        <b className="label">Disciplina:</b>
                        {item.moduleName}
                      </p>
                      <p className="info lesson">
                        <b className="label">Aula:</b>
                        {item.lessonName}
                      </p>
                      <p className="info chapter">
                        <b className="label">Capítulo:</b>
                        {item.chapterName}
                      </p>
                    </div>

                    <p className="type">Formato {item.type === 'excerto' ? 'PDF' : 'Vídeo'}</p>
                  </div>
                </Card>
              </div>
            ))}
          </Carousel>
        </Container>
      ) : (
        ''
      )}
    </>
  )
}

export default ContinueContent
